webpackJsonp([1],{

/***/ "+X1z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__settings_dev__ = __webpack_require__("T1Kr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__settings_dev___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__settings_dev__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings_prod__ = __webpack_require__("nTml");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings_prod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__settings_prod__);




var Settings = function Settings() {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Settings);

  var json = void 0;
  if (location.hostname.indexOf('local') >= 0) {
    json = __WEBPACK_IMPORTED_MODULE_1__settings_dev___default.a;
  } else {
    json = __WEBPACK_IMPORTED_MODULE_2__settings_prod___default.a;
  }

  for (var key in json) {
    if (json.hasOwnProperty(key)) {
      this[key] = json[key];
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new Settings());

/***/ }),

/***/ "/Q6s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Base_vue__ = __webpack_require__("m0tV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cca1d7e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Base_vue__ = __webpack_require__("ZL/L");
function injectStyle (ssrContext) {
  __webpack_require__("VOh5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Base_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cca1d7e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Base_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6peK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  clearState: function clearState() {
    sessionStorage.clear();
  },
  getState: function getState(key) {
    return sessionStorage.getItem(key);
  },
  setState: function setState(key, value) {
    sessionStorage.setItem(key, value);
  }
});

/***/ }),

/***/ "9iai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources__ = __webpack_require__("9k9s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities__ = __webpack_require__("yp89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__("bGai");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Spot',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__utilities__["a" /* communicationUtil */]],
  data: function data() {
    return {
      loading: false,
      actionTypes: [],
      seasons: [],
      availableSpots: [],
      spot: {},
      modal: {
        visible: false,
        type: '',
        value: undefined
      }
    };
  },
  components: {
    loader: __WEBPACK_IMPORTED_MODULE_5__components__["a" /* Loader */]
  },
  mounted: function mounted() {
    var _this = this;

    this.availableSpots = this.$store.getters.availableSpots;
    this.loadDetails().then(this.loadActionTypes).then(this.loadSeasons).then(function () {
      _this.loading = false;
    });
  },
  computed: {
    hasNotes: function hasNotes() {
      return this.spot && this.spot.notes && this.spot.notes.length > 0;
    },
    isFirstSpot: function isFirstSpot() {
      return this.availableSpots.indexOf(this.spot.id) === 0;
    },
    isLastSpot: function isLastSpot() {
      return this.availableSpots.indexOf(this.spot.id) === this.availableSpots.length - 1;
    },
    overdue: function overdue() {
      if (!this.spot.latest_watered) {
        return true;
      }

      return __WEBPACK_IMPORTED_MODULE_4_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_4_moment___default()(this.spot.latest_watered.time_of_visit), 'days') > this.spot.plant_type.visit_frequency;
    },
    season: function season() {
      return this.spot.season || {
        id: 1,
        title: 'Ej planterad (tom)'
      };
    },
    map: function map() {
      return __WEBPACK_IMPORTED_MODULE_1__resources__["a" /* settings */].backend + '/spot/' + this.spot.id + '/map';
    },
    latestActions: function latestActions() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.spot.latest_visit.spot_actions.map(function (a) {
        return a.action.title;
      })), [this.spot.latest_visit.comment]).filter(function (x) {
        return x;
      }).join(', ');
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format('YYYY-MM-DD');
    },
    loadActionTypes: function loadActionTypes() {
      var _this2 = this;

      return this.get(__WEBPACK_IMPORTED_MODULE_1__resources__["a" /* settings */].backend + '/actions/types').then(function (response) {
        _this2.actionTypes = response.data;
      });
    },
    loadDetails: function loadDetails() {
      var _this3 = this;

      var spotId = this.$store.getters.selectedSpot;

      this.loading = true;

      return this.get(__WEBPACK_IMPORTED_MODULE_1__resources__["a" /* settings */].backend + '/spot/' + spotId + '/details').then(function (response) {
        _this3.spot = response.data;
      });
    },
    loadSeasons: function loadSeasons() {
      var _this4 = this;

      return this.get(__WEBPACK_IMPORTED_MODULE_1__resources__["a" /* settings */].backend + '/season/list').then(function (response) {
        _this4.seasons = response.data;
      });
    },
    showArea: function showArea() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/area');
    },
    showDescription: function showDescription() {
      this.modal.visible = true;
      this.modal.type = 'description';
    },
    showActionDialog: function showActionDialog() {
      this.modal.visible = true;
      this.modal.type = 'action';
      this.modal.value = {
        actions: [],
        comment: ''
      };
    },
    showNoteDialog: function showNoteDialog(note) {
      this.modal.type = 'note';
      this.modal.value = {
        id: note ? note.id : 0,
        value: note ? note.value : ''
      };
      this.modal.visible = true;
    },
    showRemoveNoteDialog: function showRemoveNoteDialog(note) {
      this.modal.type = 'confirm';
      this.modal.value = note;
      this.modal.visible = true;
    },
    showSeasonDialog: function showSeasonDialog() {
      this.modal.visible = true;
      this.modal.type = 'season';
      this.modal.value = this.spot.season.id;
    },
    showPreviousSpot: function showPreviousSpot() {
      var _this5 = this;

      var newSpotId = this.availableSpots[this.availableSpots.indexOf(this.spot.id) - 1];
      this.$store.commit('spot', newSpotId);
      this.loadDetails().then(function (response) {
        _this5.loading = false;
      });
    },
    showNextSpot: function showNextSpot() {
      var _this6 = this;

      var newSpotId = this.availableSpots[this.availableSpots.indexOf(this.spot.id) + 1];
      this.$store.commit('spot', newSpotId);
      this.loadDetails().then(function (response) {
        _this6.loading = false;
      });
    },
    closeModal: function closeModal(e) {
      this.modal.visible = false;
      this.modal.type = '';
    },
    preventModalClose: function preventModalClose(e) {
      e.stopImmediatePropagation();
    },
    saveAction: function saveAction() {
      var _this7 = this;

      this.loading = true;

      this.post(__WEBPACK_IMPORTED_MODULE_1__resources__["a" /* settings */].backend + '/spot/' + this.spot.id + '/perform_action', {
        actions: this.modal.value.actions,
        comment: this.modal.value.comment === '' ? undefined : this.modal.value.comment
      }).then(function (response) {
        if (response.data.spot_actions.find(function (_ref) {
          var action = _ref.action;
          return action.count_as_visited === 1;
        })) {
          _this7.spot.latest_visit = response.data;
        }
        if (response.data.spot_actions.find(function (_ref2) {
          var action = _ref2.action;
          return action.count_as_watered === 1;
        })) {
          _this7.spot.latest_watered = response.data;
        }
        _this7.loading = false;
        _this7.closeModal();
      });
    },
    saveSeason: function saveSeason() {
      var _this8 = this;

      if (this.spot.season.id !== this.modal.value) {
        this.loading = true;

        this.post(__WEBPACK_IMPORTED_MODULE_1__resources__["a" /* settings */].backend + '/spot/' + this.spot.id + '/change_season', {
          season: this.modal.value
        }).then(function (response) {
          _this8.spot.season = response.data;
          _this8.loading = false;
          _this8.closeModal();
        });
        return;
      }

      this.closeModal();
    },
    saveNote: function saveNote() {
      var _this9 = this;

      this.loading = true;

      this.post(__WEBPACK_IMPORTED_MODULE_1__resources__["a" /* settings */].backend + '/spot/' + this.spot.id + '/save_note', {
        id: this.modal.value.id,
        value: this.modal.value.value
      }).then(function (response) {
        _this9.spot.notes = response.data;
        _this9.loading = false;
        _this9.closeModal();
      });
    },
    removeNote: function removeNote() {
      var _this10 = this;

      this.loading = true;

      this.post(__WEBPACK_IMPORTED_MODULE_1__resources__["a" /* settings */].backend + '/spot/' + this.spot.id + '/remove_note', {
        id: this.modal.value.id
      }).then(function (response) {
        _this10.spot.notes = response.data;
        _this10.loading = false;
        _this10.closeModal();
      });
    },
    toggleAction: function toggleAction(id) {
      if (this.modal.value.actions.includes(id)) {
        this.modal.value.actions = this.modal.value.actions.filter(function (v) {
          return v !== id;
        });
        return;
      }

      this.modal.value.actions.push(id);
    }
  }
});

/***/ }),

/***/ "9k9s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__settings__ = __webpack_require__("+X1z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__("6peK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IN8m");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__settings__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__state__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__store__["a"]; });






/***/ }),

/***/ "EW/Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('ul',{staticClass:"button-list"},[_c('li',{staticClass:"button-list-item",on:{"click":function($event){return _vm.showArea()}}},[_c('span',{staticClass:"button-list-item-caption"},[_vm._v("Alla")]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_vm._l((_vm.orderedAreas),function(area){return _c('li',{key:area.id,staticClass:"button-list-item",on:{"click":function($event){return _vm.showArea(area)}}},[_c('span',{staticClass:"button-list-item-caption"},[_vm._v(_vm._s(area.title))]),_vm._v(" "),_vm._m(2,true)])})],2)])]),_vm._v(" "),(_vm.loading)?_c('loader'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h1',[_c('span',[_vm._v("Områden")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"button-list-item-icon"},[_c('i',{staticClass:"fa fa-chevron-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"button-list-item-icon"},[_c('i',{staticClass:"fa fa-chevron-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Evi6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resources__ = __webpack_require__("9k9s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities__ = __webpack_require__("yp89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__("bGai");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AreaList',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__utilities__["a" /* communicationUtil */]],
  data: function data() {
    return {
      areas: [],
      loading: false
    };
  },
  mounted: function mounted() {
    this.loadAreas();
  },
  components: {
    loader: __WEBPACK_IMPORTED_MODULE_3__components__["a" /* Loader */]
  },
  computed: {
    orderedAreas: function orderedAreas() {
      return this.areas.sort(function (a, b) {
        return a.sort_id - b.sort_id;
      });
    }
  },
  methods: {
    handleException: function handleException(exception) {
      console.log('Exception', exception);
    },
    loadAreas: function loadAreas() {
      var _this = this;

      this.loading = true;
      this.get(__WEBPACK_IMPORTED_MODULE_0__resources__["a" /* settings */].backend + '/areas/list').then(function (response) {
        _this.areas = response.data;
        _this.loading = false;
      });
    },
    showArea: function showArea(area) {
      this.$store.commit('area', area ? area.id : -1);
      this.$store.commit('areaType', area && area.virtual ? 'virtual' : 'regular');
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/area');
    }
  }
});

/***/ }),

/***/ "GaE3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h1',[_c('button',{staticClass:"btn btn-sm btn-dark back",attrs:{"type":"button"},on:{"click":_vm.showAreaList}},[_c('i',{staticClass:"fa fa-caret-left"}),_vm._v("\n          Tillbaka\n        ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.area.title)+" "+_vm._s(_vm.selectedFilter !== _vm.filters[0] ? '(Filtrerad)' : ''))]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-dark filter",attrs:{"type":"button"},on:{"click":_vm.showFilterModal}},[_vm._v("\n          Filtrera\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('ul',{staticClass:"button-list"},_vm._l((_vm.filteredSpots),function(spot,index){return _c('li',{key:spot.id,staticClass:"button-list-item has-season",class:{ 'has-note': spot.notes.length > 0 },on:{"click":function($event){return _vm.showSpot(spot, index)}}},[_c('span',{staticClass:"button-list-item-season",class:'season-' + _vm.getSeason(spot)}),_vm._v(" "),_c('span',{staticClass:"button-list-item-caption"},[_vm._v(_vm._s(spot.title))]),_vm._v(" "),_c('span',{staticClass:"button-list-item-comment"},[_vm._v("(TS: "+_vm._s(_vm.daysSince(spot, 'latest_visit'))+",\n            "),_c('span',{class:{ overdue: _vm.isOverdue(spot) }},[_vm._v("V: "+_vm._s(_vm.daysSince(spot, 'latest_watered')))]),_vm._v(")")]),_vm._v(" "),_vm._m(0,true)])}),0)])]),_vm._v(" "),(_vm.filterModal.visible)?_c('div',{staticClass:"overlay",on:{"click":_vm.closeFilterModal}},[_c('div',{staticClass:"dialog"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"dialog-body"},[_c('label',{attrs:{"for":"filter"}},[_vm._v("Filter:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterModal.selectedFilter),expression:"filterModal.selectedFilter"}],staticClass:"form-control",attrs:{"id":"filter"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filterModal, "selectedFilter", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.filters),function(filter){return _c('option',{domProps:{"value":filter}},[_vm._v(_vm._s(filter.caption))])}),0),_vm._v(" "),_c('button',{staticClass:"btn btn-light form-control",attrs:{"type":"button"},on:{"click":_vm.saveFilter}},[_vm._v("Spara")]),_vm._v(" "),_c('button',{staticClass:"btn btn-light form-control cancel",attrs:{"type":"button"},on:{"click":_vm.closeFilterModal}},[_vm._v("Avbryt")])])])]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('loader'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"button-list-item-icon"},[_c('i',{staticClass:"fa fa-chevron-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-header"},[_c('h2',[_vm._v("Filtrera")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IN8m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persist__ = __webpack_require__("jcKD");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var persistantStore = new __WEBPACK_IMPORTED_MODULE_2_vuex_persist__["a" /* default */]({
  key: 'navigabilis',
  storage: window.localStorage
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    selectedArea: undefined,
    selectedAreaType: undefined,
    selectedSpot: undefined,
    availableSpots: undefined
  },
  plugins: [persistantStore.plugin],
  getters: {
    selectedArea: function selectedArea(state) {
      return state.selectedArea;
    },
    selectedAreaType: function selectedAreaType(state) {
      return state.selectedAreaType;
    },
    selectedSpot: function selectedSpot(state) {
      return state.selectedSpot;
    },
    availableSpots: function availableSpots(state) {
      return state.availableSpots;
    }
  },
  mutations: {
    area: function area(state, payload) {
      state.selectedArea = payload;
    },
    areaType: function areaType(state, payload) {
      state.selectedAreaType = payload;
    },
    spot: function spot(state, payload) {
      state.selectedSpot = payload;
    },
    availableSpots: function availableSpots(state, payload) {
      state.availableSpots = payload;
    }
  }
}));

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e705fce2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("k4di");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e705fce2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources__ = __webpack_require__("9k9s");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#navigabilis',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__resources__["c" /* store */],
  template: '<App />',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "QITP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Area_vue__ = __webpack_require__("rlgF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e636a4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Area_vue__ = __webpack_require__("GaE3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Area_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e636a4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Area_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T1Kr":
/***/ (function(module, exports) {

module.exports = {"backend":"http://cellarium.tiits.local","user":"bite","token":"7dfSmG10u60P!t9Xl@teKMxMc5#i5FHy"}

/***/ }),

/***/ "VOh5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources__ = __webpack_require__("9k9s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views__ = __webpack_require__("fTIY");







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var exposedPaths = ['/areas', '/area', '/spot'];
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__views__["c" /* Base */],
    children: [{
      path: '/areas',
      name: 'AreaList',
      component: __WEBPACK_IMPORTED_MODULE_3__views__["b" /* AreaList */]
    }, {
      path: '/area',
      name: 'Area',
      component: __WEBPACK_IMPORTED_MODULE_3__views__["a" /* Area */]
    }, {
      path: '/spot',
      name: 'Spot',
      component: __WEBPACK_IMPORTED_MODULE_3__views__["d" /* Spot */]
    }]
  }]
});

router.beforeEach(function (to, from, next) {
  if (exposedPaths.indexOf(to.path) === -1) {
    var auth = __WEBPACK_IMPORTED_MODULE_2__resources__["b" /* state */].getState('auth');

    if (!auth) {
      next('/areas');
    }
  }

  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "ZL/L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZSrZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay"},[_c('div',{staticClass:"loader"},[_c('i',{staticClass:"fa fa-2x fa-spinner fa-spin"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bGai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loader__ = __webpack_require__("wd27");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Loader__["a"]; });




/***/ }),

/***/ "di5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12"},[(!_vm.loading)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h1',[_c('button',{staticClass:"btn btn-sm btn-dark back",attrs:{"type":"button"},on:{"click":_vm.showArea}},[_c('i',{staticClass:"fa fa-caret-left"}),_vm._v("\n            Tillbaka\n          ")]),_vm._v(" "),_c('span',[_vm._v("Detaljer")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-dark filter",attrs:{"type":"button"},on:{"click":_vm.showDescription}},[_vm._v("\n            Beskrivning\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"row content"},[_c('div',{staticClass:"col-sm-12"},[_c('a',{staticClass:"map",attrs:{"href":'http://maps.google.com/?q=' + _vm.spot.latitude + ',' + _vm.spot.longitude}},[(_vm.spot.id)?_c('img',{attrs:{"src":_vm.map,"alt":"Karta"}}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.spot.title))])])]),_vm._v(" "),_c('div',{staticClass:"row content"},[_c('ul',{staticClass:"stats"},[_c('li',{staticClass:"stats-item"},[_c('span',{staticClass:"stats-item-caption"},[_vm._v("Planterat")]),_vm._v(" "),_c('span',{staticClass:"stats-item-season",class:("season-" + (_vm.season.id))}),_vm._v(" "),_c('span',{staticClass:"stats-item-value"},[_vm._v(_vm._s(_vm.season.title))])]),_vm._v(" "),(_vm.spot.plant_type)?_c('li',{staticClass:"stats-item"},[_c('span',{staticClass:"stats-item-caption"},[_vm._v("Planteringstyp")]),_vm._v(" "),_c('span',{staticClass:"stats-item-value"},[_vm._v(_vm._s(_vm.spot.plant_type.title))])]):_vm._e(),_vm._v(" "),(_vm.spot.latest_visit)?_c('li',{staticClass:"stats-item"},[_c('span',{staticClass:"stats-item-caption"},[_vm._v("Senast besökt")]),_vm._v(" "),_c('span',{staticClass:"stats-item-value"},[_vm._v(_vm._s(_vm.spot.latest_visit.time_of_visit))])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"stats-item"},[_c('span',{staticClass:"stats-item-caption"},[_vm._v("Senast vattnad")]),_vm._v(" "),_c('span',{staticClass:"stats-item-value",class:{ overdue: _vm.overdue }},[_vm._v(_vm._s(_vm.spot.latest_watered ? _vm.spot.latest_watered.time_of_visit : 'Aldrig'))])]),_vm._v(" "),(_vm.spot.latest_visit)?_c('li',{staticClass:"stats-item"},[_c('span',{staticClass:"stats-item-caption"},[_vm._v("Senaste tillsyn")]),_vm._v(" "),_c('span',{staticClass:"stats-item-value"},[_vm._v(_vm._s(_vm.latestActions))])]):_vm._e()])]),_vm._v(" "),(_vm.hasNotes)?_c('div',{staticClass:"row content"},[_c('ul',{staticClass:"notes"},_vm._l((_vm.spot.notes),function(note){return _c('li',{key:note.id,staticClass:"notes-item"},[_c('span',{staticClass:"notes-item-value"},[_c('span',{staticClass:"notes-item-date"},[_vm._v("\n              "+_vm._s(_vm.formatDate(note.created_at))+"\n            ")]),_vm._v("\n            "+_vm._s(note.value)+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"pull-right notes-item-actions"},[_c('i',{staticClass:"fa fa-pencil",on:{"click":function($event){return _vm.showNoteDialog(note)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-times",on:{"click":function($event){return _vm.showRemoveNoteDialog(note)}}})])])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row content"},[_c('div',{staticClass:"col-sm-12 actions"},[(!_vm.isFirstSpot)?_c('button',{staticClass:"btn btn-light form-control",on:{"click":_vm.showPreviousSpot}},[_vm._v("\n          Föregående\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-light form-control",on:{"click":_vm.showActionDialog}},[_vm._v("\n          Tillsyn\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-light form-control",on:{"click":_vm.showSeasonDialog}},[_vm._v("\n          Byt säsong\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-light form-control",on:{"click":function($event){return _vm.showNoteDialog()}}},[_vm._v("\n          Lägg till anteckning\n        ")]),_vm._v(" "),(!_vm.isLastSpot)?_c('button',{staticClass:"btn btn-light form-control",on:{"click":_vm.showNextSpot}},[_vm._v("\n          Nästa\n        ")]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.modal.visible)?_c('div',{staticClass:"overlay",on:{"click":_vm.closeModal}},[(_vm.modal.type === 'description')?_c('div',{staticClass:"dialog",on:{"click":_vm.preventModalClose}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"dialog-body"},[_c('p',[_vm._v("\n          "+_vm._s(this.spot.description)+"\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-light form-control btn-close",attrs:{"type":"button"},on:{"click":_vm.closeModal}},[_vm._v("\n          Stäng\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.modal.type === 'action')?_c('div',{staticClass:"dialog",on:{"click":_vm.preventModalClose}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"dialog-body"},[_c('form',[_c('div',{staticClass:"form-group vertical"},[_c('label',[_vm._v("Typ av tillsyn")]),_vm._v(" "),_c('div',{staticClass:"btn-group-vertical actions",attrs:{"role":"group"}},_vm._l((_vm.actionTypes),function(actionType,index){return _c('button',{key:index,staticClass:"btn btn-light btn-sm",class:{ active: _vm.modal.value.actions && _vm.modal.value.actions.includes(actionType.id) },attrs:{"type":"button"},on:{"click":function () { return _vm.toggleAction(actionType.id); }}},[_vm._v("\n                "+_vm._s(actionType.title)+"\n              ")])}),0),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Kommentar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modal.value.comment),expression:"modal.value.comment"}],staticClass:"form-control",domProps:{"value":(_vm.modal.value.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modal.value, "comment", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-light form-control",attrs:{"type":"button"},on:{"click":_vm.saveAction}},[_vm._v("\n              Spara\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-light form-control btn-close",attrs:{"type":"button"},on:{"click":_vm.closeModal}},[_vm._v("\n              Avbryt\n            ")])])])])]):_vm._e(),_vm._v(" "),(_vm.modal.type === 'season')?_c('div',{staticClass:"dialog",on:{"click":_vm.preventModalClose}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"dialog-body"},[_c('form',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Planterat:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.modal.value),expression:"modal.value"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.modal, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.seasons),function(season,index){return _c('option',{key:index,domProps:{"value":season.id}},[_vm._v(_vm._s(season.title))])}),0),_vm._v(" "),_c('button',{staticClass:"btn btn-light form-control",attrs:{"type":"button"},on:{"click":_vm.saveSeason}},[_vm._v("\n              Spara\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-light form-control btn-close",attrs:{"type":"button"},on:{"click":_vm.closeModal}},[_vm._v("\n              Avbryt\n            ")])])])])]):_vm._e(),_vm._v(" "),(_vm.modal.type === 'confirm')?_c('div',{staticClass:"dialog",on:{"click":_vm.preventModalClose}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"dialog-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-light form-control",on:{"click":_vm.removeNote}},[_vm._v("\n              Ta bort\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-light form-control",on:{"click":_vm.closeModal}},[_vm._v("\n              Avbryt\n            ")])])])])]):_vm._e(),_vm._v(" "),(_vm.modal.type === 'note')?_c('div',{staticClass:"dialog",on:{"click":_vm.preventModalClose}},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"dialog-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Anteckning")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.modal.value.value),expression:"modal.value.value"}],staticClass:"form-control",domProps:{"value":(_vm.modal.value.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modal.value, "value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-light form-control",on:{"click":_vm.saveNote}},[_vm._v("\n              Spara\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-light form-control",on:{"click":_vm.closeModal}},[_vm._v("\n              Avbryt\n            ")])])])])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('loader'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-header"},[_c('h2',[_vm._v("Beskrivning")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-header"},[_c('h2',[_vm._v("Tillsyn")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-header"},[_c('h2',[_vm._v("Byt säsong")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-header"},[_c('h2',[_vm._v("Ta bort kommentar")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-header"},[_c('h2',[_c('span',[_vm._v("Redigera anteckning")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fTIY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Area__ = __webpack_require__("QITP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AreaList__ = __webpack_require__("v1DE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Base__ = __webpack_require__("/Q6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Spot__ = __webpack_require__("oDPU");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Base__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__AreaList__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Area__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__Spot__["a"]; });







/***/ }),

/***/ "k4di":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"navigabilis"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m0tV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Base'
});

/***/ }),

/***/ "nTml":
/***/ (function(module, exports) {

module.exports = {"backend":"https://cellarium.tiits.se","user":"bite","token":"7dfSmG10u60P!t9Xl@teKMxMc5#i5FHy"}

/***/ }),

/***/ "oDPU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spot_vue__ = __webpack_require__("9iai");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41a0b50d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spot_vue__ = __webpack_require__("di5B");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41a0b50d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oVb5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rlgF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources__ = __webpack_require__("9k9s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities__ = __webpack_require__("yp89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__("bGai");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Area',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__utilities__["a" /* communicationUtil */]],
  data: function data() {
    var overdueCheck = this.isOverdue;
    var areaType = this.$store.getters.selectedAreaType;
    var defaultFilters = [{
      caption: 'Inget filter',
      execute: function execute(spots) {
        return spots;
      }
    }, {
      caption: 'Senast besökt över tiden',
      execute: function execute(spots) {
        return spots.filter(function (spot) {
          return overdueCheck(spot);
        });
      }
    }];

    return {
      loading: false,
      area: {
        spots: []
      },
      type: areaType,
      filterModal: {
        defaultFilters: defaultFilters,
        visible: false,
        selectedFilter: defaultFilters[0]
      },
      selectedFilter: defaultFilters[0],
      seasons: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    var areaId = this.$store.getters.selectedArea;

    this.loading = true;
    this.get(__WEBPACK_IMPORTED_MODULE_2__resources__["a" /* settings */].backend + '/season/list').then(function (response) {
      _this.seasons = response.data;
    });
    if (areaId > 0) {
      this.get(__WEBPACK_IMPORTED_MODULE_2__resources__["a" /* settings */].backend + '/area/' + areaId + '/details?type=' + this.type).then(function (response) {
        _this.area = response.data;
        _this.plantTypes = _this.getUniquePlantTypes(response.data.spots.map(function (spot) {
          return spot.plant_type;
        }));
        _this.loading = false;
      });
      return;
    }

    this.get(__WEBPACK_IMPORTED_MODULE_2__resources__["a" /* settings */].backend + '/spots/all').then(function (response) {
      _this.area = {
        spots: response.data,
        name: 'Alla'
      };
      _this.plantTypes = _this.getUniquePlantTypes(response.data.map(function (spot) {
        return spot.plant_type;
      }));
      _this.loading = false;
    });
  },
  components: {
    loader: __WEBPACK_IMPORTED_MODULE_6__components__["a" /* Loader */]
  },
  computed: {
    filters: function filters() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.filterModal.defaultFilters), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.plantTypes.map(function (plantType) {
        return {
          caption: 'Planteringstyp: ' + plantType.title,
          execute: function execute(spots) {
            return spots.filter(function (spot) {
              return spot.plant_type.id === plantType.id;
            });
          }
        };
      })), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.seasons.map(function (season) {
        return {
          caption: 'S\xE4song ' + season.title,
          execute: function execute(spots) {
            return spots.filter(function (spot) {
              return spot.season.id === season.id;
            });
          }
        };
      })));
    },
    filteredSpots: function filteredSpots() {
      var _this2 = this;

      return (this.selectedFilter.execute ? this.selectedFilter.execute(this.area.spots) : this.area.spots).sort(function (a, b) {
        if (_this2.type === 'virtual') {
          return a.pivot.sort_id - b.pivot.sort_id;
        }
        return a.sort_id - b.sort_id;
      });
    }
  },
  methods: {
    handleException: function handleException(exception) {
      console.log('Exception', exception);
    },
    getUniquePlantTypes: function getUniquePlantTypes(plantTypes) {
      var plantTypeMap = {};

      plantTypes.forEach(function (plantType) {
        if (!plantTypeMap[plantType.id]) {
          plantTypeMap[plantType.id] = plantType;
        }
      });

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(plantTypeMap);
    },
    daysSince: function daysSince(spot, type) {
      return spot[type] ? __WEBPACK_IMPORTED_MODULE_5_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(spot[type].time_of_visit), 'days') : 'Aldrig';
    },
    isOverdue: function isOverdue(spot) {
      if (!spot.latest_watered) {
        return true;
      }

      return this.daysSince(spot, 'latest_watered') > spot.plant_type.visit_frequency;
    },
    closeFilterModal: function closeFilterModal(e) {
      if (e.target.className === 'overlay' || e.target.className === 'btn btn-light form-control cancel') {
        this.filterModal.visible = false;
      }
    },
    getSeason: function getSeason(spot) {
      return spot.season ? spot.season.id : 1;
    },
    saveFilter: function saveFilter() {
      this.selectedFilter = this.filterModal.selectedFilter;
      this.filterModal.visible = false;
    },
    showAreaList: function showAreaList() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/areas');
    },
    showFilterModal: function showFilterModal() {
      this.filterModal.selectedFilter = this.selectedFilter;
      this.filterModal.visible = true;
    },
    showSpot: function showSpot(spot) {
      this.$store.commit('spot', spot.id);
      this.$store.commit('availableSpots', this.filteredSpots.map(function (spot) {
        return spot.id;
      }));
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/spot');
    }
  }
});

/***/ }),

/***/ "uExR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Loader',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "uWbM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resources__ = __webpack_require__("9k9s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    delete: function _delete(url) {
      var headers = {
        headers: {
          Authorization: __WEBPACK_IMPORTED_MODULE_0__resources__["a" /* settings */].user + '|' + __WEBPACK_IMPORTED_MODULE_0__resources__["a" /* settings */].token
        }
      };

      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(url, headers);
    },
    get: function get(url) {
      var headers = {
        headers: {
          Authorization: __WEBPACK_IMPORTED_MODULE_0__resources__["a" /* settings */].user + '|' + __WEBPACK_IMPORTED_MODULE_0__resources__["a" /* settings */].token
        }
      };

      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, headers);
    },
    post: function post(url, data) {
      var headers = {
        headers: {
          Authorization: __WEBPACK_IMPORTED_MODULE_0__resources__["a" /* settings */].user + '|' + __WEBPACK_IMPORTED_MODULE_0__resources__["a" /* settings */].token
        }
      };

      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, data, headers);
    }
  }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v1DE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreaList_vue__ = __webpack_require__("Evi6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e16276f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AreaList_vue__ = __webpack_require__("EW/Q");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreaList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e16276f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AreaList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wd27":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__ = __webpack_require__("uExR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74ba4bde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__("ZSrZ");
function injectStyle (ssrContext) {
  __webpack_require__("oVb5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74ba4bde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yp89":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__communication__ = __webpack_require__("uWbM");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__communication__["a"]; });




/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b828c29c5eec5301ce18.js